import { ReactNode } from 'react';
import { IControlProps, IPartialFormGroup } from '../types';
import FormControl from '../FormControl';
import Textarea, { ITextareaProps } from '../../atoms/Textarea';
import { useHookFormController } from '../../hooks/useHookFormController';

export type ITextareaBase64ControlProps = ITextareaProps &
    IControlProps & {
        formGroupProps?: IPartialFormGroup;
        label?: ReactNode;
        tooltip?: ReactNode;
        required?: boolean;
    };

const TextareaBase64Control = ({
    name,
    rules,
    defaultValue,
    control,
    shouldUnregister,
    label,
    tooltip,
    required,
    formGroupProps,
    onValueChange,
    ...props
}: ITextareaBase64ControlProps) => {
    const Controller = useHookFormController();

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            shouldUnregister={shouldUnregister}
            defaultValue={defaultValue}
            render={({ field: { onChange, value, ...fieldProps } }) => (
                <FormControl
                    readonlyAppearance={props.readOnly || props.disabled ? 'field' : undefined}
                    name={name}
                    label={label}
                    tooltip={tooltip}
                    required={required}
                    control={control}
                    {...formGroupProps}
                >
                    <Textarea
                        {...fieldProps}
                        {...props}
                        value={value ? decodeURIComponent(escape(atob(value))) : ''}
                        onValueChange={(val) => {
                            const encodedVal = btoa(unescape(encodeURIComponent(val)));
                            onChange(encodedVal);
                            onValueChange && onValueChange(encodedVal);
                        }}
                    />
                </FormControl>
            )}
        />
    );
};

export default TextareaBase64Control;
